export const alertMenuDef = [
  {
    name: 'Alert Event Master',
    resource: 'event_master',
    icon: 'fa fa-plus-square',
    url: 'event_master',
    auto_crud: true,
    breadcrumb: 'Alert Event Master',
    showMenu: true
  },
  {
    name: 'menu.error_handling',
    resource: 'mis_error_handling',
    icon: 'fa fa-plus-square',
    url: 'mis_error_handling',
    auto_crud: true,
    breadcrumb: 'Error Handling',
    showMenu: true
  },
  {
    name: 'Alert Event Recipients',
    resource: 'event_recipients',
    icon: 'fa fa-plus-square',
    url: 'event_recipients',
    auto_crud: true,
    breadcrumb: 'Alert Event Recipients',
    showMenu: true
  },
  {
    name: 'Discharge Stage Wise Alert',
    resource: 'discharge_stage_wise_alert',
    icon: 'fa fa-plus-square',
    url: 'discharge_stage_wise_alert',
    auto_crud: true,
    breadcrumb: 'Discharge Stage Wise Alert',
    showMenu: false
  },
  {
    "name": "Templates",
    "icon": "fa fa-tags",
    "data": {
      "nav_url": "valueset_karexpert_m"
    },
    "children": [
      {
        name: 'SMS Template',
        resource: 'sms_channel_template',
        icon: 'fa fa-plus-square',
        url: 'sms_channel_template',
        auto_crud: true,
        breadcrumb: 'SMS Template',
        showMenu: true
      },
      {
        name: 'Email Template',
        resource: 'email_channel_template',
        icon: 'fa fa-plus-square',
        url: 'email_channel_template',
        auto_crud: true,
        breadcrumb: 'Email Template',
        showMenu: true
      },
      {
        name: 'Whatsapp Template',
        resource: 'whatsapp_channel_template',
        icon: 'fa fa-plus-square',
        url: 'whatsapp_channel_template',
        auto_crud: true,
        breadcrumb: 'Whatsapp Template',
        showMenu: true
      },
      {
        name: 'Notification Template',
        resource: 'notification_channel_template',
        icon: 'fa fa-plus-square',
        url: 'notification_channel_template',
        auto_crud: true,
        breadcrumb: 'Notificationmail Template',
        showMenu: true
      }
    ]
  },
  {
    "name": "Gateway Information",
    "icon": "fa fa-tags",
    "data": {
      "nav_url": "valueset_karexpert_m"
    },
    "children": [
      {
        name: 'Email Account',
        resource: 'email_account',
        icon: 'fa fa-plus-square',
        url: 'email_account',
        auto_crud: true,
        breadcrumb: 'Email Account',
        showMenu: true
      },
      {
        name: 'SMS Account',
        resource: 'sms_account',
        icon: 'fa fa-plus-square',
        url: 'sms_account',
        auto_crud: true,
        breadcrumb: 'SMS Account',
        showMenu: true
      },
      {
        name: 'Push Account',
        resource: 'push_account',
        icon: 'fa fa-plus-square',
        url: 'push_account',
        auto_crud: true,
        breadcrumb: 'Push Account',
        showMenu: true
      }
    ]
  },
  {
    name: 'Alert Copy',
    resource: 'alertCopy',
    icon: 'fa fa-plus-square',
    url: 'alertCopy',
    auto_crud: true,
    breadcrumb: 'Alert Copy',
    showMenu: true
  },
  {
    "name": "Alert DND",
    "icon": "fa fa-tags",
    "data": {
      "nav_url": "valueset_karexpert_m"
    },
    "children": [
      {
        name: 'Email DND',
        resource: 'email_dnd',
        icon: 'fa fa-plus-square',
        url: 'email_dnd',
        auto_crud: true,
        breadcrumb: 'Email DND',
        showMenu: true
      },
      {
        name: 'Mobile DND',
        resource: 'mobile_dnd',
        icon: 'fa fa-plus-square',
        url: 'mobile_dnd',
        auto_crud: true,
        breadcrumb: 'Moble DND',
        showMenu: true
      }
    ]
  },
  {
    name: 'Alerts Switch',
    resource: 'alert_facility_status',
    icon: 'fa fa-plus-square',
    url: 'alert_facility_status',
    auto_crud: true,
    breadcrumb: 'Alerts Switch',
    showMenu: true
  }
]